import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { CONTENT as DEFAULTS } from "@/lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext({ content: DEFAULTS, loading: true, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/settings`);
      if (data && typeof data === "object") setContent(data);
    } catch (e) {
      // fall back to bundled defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ content, setContent, loading, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext).content;
export const useSettingsCtx = () => useContext(SettingsContext);
